



















import { Component, Prop } from 'vue-property-decorator'

import { ButtonView, SocketNames } from "../../../../../../components";
import ConstantValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/ConstantValue'
import PropertyValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/PropertyValue';
import { SampleNodeMixin } from '../../../../index'
import { IntegrationNode } from '../../logic/IntegrationNode'

@Component({
  components: {
    ButtonView
  },
  data() {
    return {
      PropertyValue,
      ConstantValue,
      SocketNames
    }
  }
})
export default class IntegrationSampleNode extends SampleNodeMixin {
  @Prop() node!: IntegrationNode
}
